import { useEffect, useRef, useState } from "react";
import { fetchCounties, fetchData } from "../../../features/fetch/fetchSlice";
import { useDispatch, useSelector } from "react-redux";
import { Form, Select } from "antd";

function Pathways() {
  const url = "api/v2/dashboard/getProjectDashboardData";
  const { loading, count, data } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const maxValue = Array.isArray(data?.projectPathways)
  ? Math.max(...data?.projectPathways?.map((d) => d?.value ?? 0))
  : 0;

  const [countyId, setCountyId] = useState(null);
  const dispatch = useDispatch();

  async function fetchDashData() {
    await dispatch(
      fetchData({
        url: url,
        limit: null,
        start: 0,
      })
    );
  }

  useEffect(() => {
    dispatch(fetchCounties());
  }, []);

  // useEffect(() => {
  //   fetchTableData();
  // }, [countyId]);
  return (
    <div className="p-[1.25rem] rounded-[.75rem] bg-white  w-full h-full">
      <div className="flex items-center justify-between">
        <span className="text-[#424242] font-interSans text-[.75rem] font-[500]">
          Projects Pathway
        </span>
        <div className="w-[30%]">
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            className="w-full"
            form={form}
          >
            <div className="w-full flex items-center gap-x-[.5rem] text-[#6B7280] text-[.875rem] font-[400] font-interSans">
              <Select
                className=""
                allowClear
                // options={
                //   counties?.length > 0 &&
                //   counties?.map((item) => ({
                //     value: item?.countyName,
                //     label: item?.countyName,
                //   }))
                // }
                value={countyId}
                onChange={(value) => setCountyId(value)}
                placeholder="Select Scheme"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
              />
            </div>
          </Form>
        </div>
      </div>
      <div className="flex flex-col gap-[3.26rem] mt-4">
        {data?.projectPathways?.map((item, index) => (
          <div key={index} className="flex items-center gap-2 relative group">
            <div className="absolute top-[-1.5rem] left-0 w-full text-center text-sm text-gray-700 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              {item?.name}
            </div>

            <div className="w-[5rem] truncate text-sm text-gray-700">
              {item?.name}
            </div>
            <div className="flex-1 bg-gray-200 h-2 rounded-full relative">
              <div
                className="h-2 rounded-full"
                style={{
                  width: `${(item?.value / maxValue) * 100}%`,
                  backgroundColor: item?.color,
                }}
              ></div>
            </div>
            <div className="w-[2rem] text-right text-sm text-gray-700">
              {item?.value}
            </div>
          </div>
        ))}
      </div>

      {/* <div className="flex flex-col gap-[3.26rem] mt-4">
        {data?.projectPathways?.map((item, index) => (
          <div key={index} className="flex items-center gap-2">
            <div className="w-[5rem] truncate text-sm text-gray-700">
              {item?.name}
            </div>
            <div className="flex-1 bg-gray-200 h-2 rounded-full relative">
              <div
                className="h-2 rounded-full"
                style={{
                  width: `${(item?.value / maxValue) * 100}%`,
                  backgroundColor: item?.color,
                }}
              ></div>
            </div>
            <div className="w-[2rem] text-right text-sm text-gray-700">
              {item?.value}
            </div>
          </div>
        ))}
      </div> */}
    </div>
  );
}

export default Pathways;
